module.exports = __webpack_public_path__ + "img/check.6ac3d38e.svg";